/**
 * Номер страницы списка хранится в адресе (?page=3), чтобы страница сохранялась
 * при обновлении, кнопке «Назад» и по ссылке, которой поделились.
 */

export const getPageFromLocation = (location) => {
    const value = parseInt(new URLSearchParams(location.search).get('page'), 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
};

export const pushPage = (history, location, page) => {
    const params = new URLSearchParams(location.search);
    if (page > 1) {
        params.set('page', String(page));
    } else {
        params.delete('page');
    }
    const search = params.toString();
    history.push({pathname: location.pathname, search: search ? `?${search}` : ''});
    window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
};
